module.exports = __webpack_public_path__ + "img/acadsoc.fb8a7712.jpg";